import { Directive, ElementRef, Input, OnInit } from '@angular/core';
import { AuthStateService } from '../services/auth-state.service';

@Directive({
  selector: '[hoverOnRight]'
})
export class HoverOnRightDirective {

  @Input() hoverOnRight: string = null;

  constructor(
    private auth: AuthStateService,
    private elementRef: ElementRef
  ) { }

  ngOnInit() {
    if (this.auth.hasRight(this.hoverOnRight)) {
      this.elementRef.nativeElement.classList.add('tr-hover');
    }
  }

}
